export const ROUTES = {
    INDEX: '/',
    LOGIN: 'https://app.silverswiftventures.com/',
    SIGNUP: 'https://app.silverswiftventures.com/signup',
    ABOUT: '/about',
    HOW_IT_WORKS: '/how-it-works',
    FAQs: '/faqs',
    CONTACTUS: '/contact-us',
    RESET_PASSWORD: '/reset-password',
    TERMS_CONDITIONS: '/terms',
    PRIVACY_POLICY: '/privacy',
    REFUND_POLICY: '/refund-policy',
    CANCELLATION_POLICY: '/cancellation-policy'
};